import React from 'react';
import { translate } from '@fiverr-private/i18n-react';
import { ButtonExpansion } from './ButtonExpansion';

type ButtonExpansionProps = React.ComponentProps<typeof ButtonExpansion>;
type ButtonExpansionMoreProps = Omit<ButtonExpansionProps, 'children'> &
    Readonly<{
        totalCount: number;
    }>;

export const ButtonExpansionMore = ({ totalCount, ...rest }: ButtonExpansionMoreProps) => (
    <ButtonExpansion {...rest}>
        {translate('seller_page_perseus.professions_page.main_content.show_all', { params: { amount: totalCount } })}
    </ButtonExpansion>
);
